import React from 'react';
import { Utils } from '../../Utils';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { withAppContext } from '../../contexts/AppContext.js';
import SlideInContent from '../AnimatedElements/SlideInContent.js';

class PopupContent extends React.Component {

  animationObjectRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
        show: false,
        content: {},
    };

    this.appRef = this.props.appContext.appRef;
    this.pendingHide = false;
  }

  // content nélkül hívva (pl. a Layout vissza gombos újranyitásakor) a korábbi tartalom marad
  show(content) {
    this.setState({show: true, content: content || this.state.content}, () => {
      setTimeout(() => this.animationObjectRef.current?.setVisible(true), 0);
    });
  }

  hide() {
    if (!this.state.show) {
      this.pendingHide = false;
      return;
    }

    this.pendingHide = true;
    this.animationObjectRef.current?.setVisible(false);
  }

  handleSlideOutComplete = () => {
    if (this.pendingHide) {
      this.pendingHide = false;
      this.setState({show: false});
    }
  }

  render() {
    const { show, content } = this.state;

    if (!show) return null;

    const is_signed = this.appRef.current.get_is_signed();

    return <SlideInContent
      ref={this.animationObjectRef}
      className={`container floating_container page_content popup ${is_signed ? 'signed' : 'unsigned'}`}
      onHidden={this.handleSlideOutComplete}
    >
      <div className="content">
        <PageHeader parent_ref={this} title={content.title} />

        <div className='container_inner'>
          <div className="page_content" dangerouslySetInnerHTML={{__html: Utils.normalize_content_html(content.content)}}></div>
        </div>
      </div>
    </SlideInContent>;
  }
}

export default withAppContext(PopupContent);
